import { Injectable } from "@angular/core";
import { ActivatedRoute, Route, Router } from "@angular/router";

@Injectable()
export class LayoutService {

    route:any;

    constructor() {

    }

    getRotte() {
        
      //  alert("1"+ this.route);
        return this.route;
    }

    impostaRotte(route:any) {
        this.route = route;
      //  alert("2"+ JSON.stringify(this.route) );
    }
}